import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
  ChallengeSuccess,
  ChallengeSuccessService
} from '@com-delta-idp/mnx-oauth';
import { Subscription } from 'rxjs';
import { LOGIN_MODAL_CHALLENGE_URL } from '../../util/login-modal.constant';
import { AnalyticsData } from '../login-authentication-screen/models/login-credentials.interface';
import { ForgotLoginScreenContent } from './modals/forgot-login.interface';

@Component({
  selector: 'idp-forgot-login',
  templateUrl: './forgot-login.component.html',
  styleUrls: ['./forgot-login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ForgotLoginComponent implements OnDestroy, OnInit {
  @Input() forgotLoginContent!: ForgotLoginScreenContent | undefined | null;
  @Input() callBackFunction!: () => void;
  @Input() fromStandAlone = false;
  @Input() machCore = false;
  @Output() formSubmitEvent: EventEmitter<ElementRef> =
    new EventEmitter<ElementRef>();

  @Output() triggerClose = new EventEmitter();

  @Output() redirectTrackingClick: EventEmitter<AnalyticsData> =
    new EventEmitter<AnalyticsData>();

  @Output() focusInvalidField: EventEmitter<string> =
    new EventEmitter<string>();

  @Output() fieldFocusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() closeOverlayMessage: EventEmitter<void> = new EventEmitter();
  @Output() inputChange: EventEmitter<string> = new EventEmitter<string>();
  viewName = 'continue';
  form!: UntypedFormGroup;
  private subscription: Subscription = new Subscription();
  pageLoadStartTime: number;
  constructor(private challengeSuccessService: ChallengeSuccessService) {
    this.pageLoadStartTime = performance.now();
  }

  ngOnInit() {
    if (this.pageLoadStartTime) {
      this.redirectTrackingClick.emit({
        action: 'Forgot Skymiles Number',
        eventDetails: 'pageLoad',
        startTime: this.pageLoadStartTime
      });
    }
    this.checkForChallengeScreen();
  }

  get showEmailIdErrorMessage() {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.forgotLoginContent?.formGroup?.get('emailId')
    );
    return (
      control &&
      this.forgotLoginContent?.forgotLoginAttributes?.emailIdControlTouched &&
      control.invalid
    );
  }

  get showFirstNameErrorMessage() {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.forgotLoginContent?.formGroup?.get('firstName')
    );
    return (
      control &&
      this.forgotLoginContent?.forgotLoginAttributes?.firstNameControlTouched &&
      control.invalid
    );
  }

  get showLastNameErrorMessage() {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.forgotLoginContent?.formGroup?.get('lastName')
    );
    return (
      control &&
      this.forgotLoginContent?.forgotLoginAttributes?.lastNameControlTouched &&
      control?.invalid
    );
  }

  firstInvalidFieldFocusEvent() {
    this.focusInvalidField.emit();
  }

  onChange() {
    this.inputChange.emit();
  }

  onFocussedOut(fieldName: string) {
    this.fieldFocusOut.emit(fieldName);
  }

  submit() {
    this.redirectTrackingClick.emit({ action: this.viewName });
    this.formSubmitEvent.emit();
  }

  onClosePop() {
    this.closeOverlayMessage.emit();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.callBackFunction();
  }

  checkForChallengeScreen(): void {
    this.subscription.add(
      this.challengeSuccessService._callBackAfterSuccessChallenge$.subscribe(
        (data: ChallengeSuccess) => {
          if (
            data?.callBack &&
            data?.url?.includes(LOGIN_MODAL_CHALLENGE_URL.FORGOT_LOGIN)
          ) {
            this.submit();
            this.challengeSuccessService.resetValues();
          }
        }
      )
    );
  }
}
